<template>
  <div :class="className" :style="{ height: height, width: width }"></div>
</template>

<!--suppress JSUnusedGlobalSymbols, JSUnresolvedFunction, SpellCheckingInspection -->
<script>
import echarts from "echarts";
import resize from "./mixins/resize";

require("echarts/theme/macarons"); // echarts theme

export default {
  mixins: [resize],
  props: {
    className: {
      type: String,
      default: "chart"
    },
    width: {
      type: String,
      default: "100%"
    },
    height: {
      type: String,
      default: "350px"
    },
    autoResize: {
      type: Boolean,
      default: true
    },
    chartData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      chart: null
    };
  },
  watch: {
    chartData: {
      deep: true,
      handler(val) {
        this.setOptions(val);
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart();
    });
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$el, "macarons");
      this.setOptions(this.chartData);
    },
    setOptions({
      totalViews,
      androidDownloads,
      iosDownloads,
      totalDownloads,
      newsViews,
      jobViews,
      nearlySevenDays
    } = {}) {
      this.chart.setOption({
        xAxis: {
          data: nearlySevenDays,
          boundaryGap: false,
          axisTick: {
            show: false
          }
        },
        grid: {
          left: 0,
          right: 25,
          bottom: 30,
          top: 70,
          containLabel: true
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross"
          },
          padding: [5, 10]
        },
        yAxis: {
          axisTick: {
            show: false
          }
        },
        legend: {
          data: [
            "总访问量",
            "游戏总量",
            "安卓下载量",
            "IOS点击量",
            "新闻浏览量",
            "职位浏览量"
          ],
          left: "center",
          top: 10
        },
        series: [
          {
            name: "总访问量",
            itemStyle: {
              normal: {
                color: "#17a2b8",
                lineStyle: {
                  color: "#17a2b8",
                  width: 2
                },
                areaStyle: {
                  color: "#f3f8ff"
                }
              }
            },
            smooth: true,
            type: "line",
            data: totalViews,
            animationDuration: 2800,
            animationEasing: "cubicInOut"
          },
          {
            name: "游戏总量",
            smooth: true,
            type: "line",
            itemStyle: {
              normal: {
                color: "#6c757d",
                lineStyle: {
                  color: "#6c757d",
                  width: 2
                },
                areaStyle: {
                  color: "#f3f8ff"
                }
              }
            },
            data: totalDownloads,
            animationDuration: 2800,
            animationEasing: "quadraticOut"
          },
          {
            name: "安卓下载量",
            smooth: true,
            type: "line",
            itemStyle: {
              normal: {
                color: "#67c23a",
                lineStyle: {
                  color: "#67c23a",
                  width: 2
                },
                areaStyle: {
                  color: "#f3f8ff"
                }
              }
            },
            data: androidDownloads,
            animationDuration: 2800,
            animationEasing: "quadraticOut"
          },
          {
            name: "IOS点击量",
            smooth: true,
            type: "line",
            itemStyle: {
              normal: {
                color: "#f56c6c",
                lineStyle: {
                  color: "#f56c6c",
                  width: 2
                },
                areaStyle: {
                  color: "#f3f8ff"
                }
              }
            },
            data: iosDownloads,
            animationDuration: 2800,
            animationEasing: "quadraticOut"
          },
          {
            name: "新闻浏览量",
            smooth: true,
            type: "line",
            itemStyle: {
              normal: {
                color: "#E6A23C",
                lineStyle: {
                  color: "#E6A23C",
                  width: 2
                },
                areaStyle: {
                  color: "#f3f8ff"
                }
              }
            },
            data: newsViews,
            animationDuration: 2800,
            animationEasing: "quadraticOut"
          },
          {
            name: "职位浏览量",
            smooth: true,
            type: "line",
            itemStyle: {
              normal: {
                color: "#3888fa",
                lineStyle: {
                  color: "#3888fa",
                  width: 2
                },
                areaStyle: {
                  color: "#f3f8ff"
                }
              }
            },
            data: jobViews,
            animationDuration: 2800,
            animationEasing: "quadraticOut"
          }
        ]
      });
    }
  }
};
</script>
